export default function() {
    const self = this
    self.loadPayables()
}
